import { createFileRoute } from "@tanstack/react-router";
import { CloudAccountsPage } from "../../../features/infrastructure/clouds";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/")({ component: Page });

function Page() {
  const { org } = Route.useParams();
  return <CloudAccountsPage org={org} />;
}
